// extracted by mini-css-extract-plugin
export var chip = "_bl-0";
export var filterDropdown = "_bl-5";
export var filterItem = "_bl-6";
export var icon = "_bl-1";
export var removeButton = "_bl-3";
export var removeIcon = "_bl-4";
export var separator = "_bl-2";